import {WishlistModal} from './wishlistModal';
import {pushNotification} from '@malt/joy-entrypoint/src/js/notification';

const WISHLISTED_CLASS = 'remove';
const UNWISHLISTED_CLASS = 'add';

function ifConnected(connectedCallback, disconnectedCallback) {
    const isConnected = $.ajax({
        url: '/api/user/connected',
        cache: false,
        async: false,
    }).responseText;

    if (isConnected === 'true') {
        connectedCallback();
    } else {
        if (disconnectedCallback) {
            disconnectedCallback();
        }
    }
}

Hop.defineModule('wishlist-items', (root, param) => {
    const $root = $(root);

    function WishlistItemsContainer($container) {
        this.init($container);
    }

    WishlistItemsContainer.prototype = {
        init: function ($container) {
            this.$root = $container;
            this.wishlistModal = new WishlistModal({
                profileItemToggle: param.withProfileItemToggle,
                profileItems: param.profileItems,
                source: param.source,
                pageWishlistId: param.pageWishlistId,
                isClient: param.isClient === 'true',
            });

            this.clickedItem;
            this.wishlistLoggedInEvent = param.wishlistLoggedInEvent;
            this.setHandlers();
        },

        updateWishlistItemsState: function () {
            const wishlistItems = this.$root.find(param.elToBeUpdated ? param.elToBeUpdated : param.wishlistItems);

            function updateWithConnectedAccount() {
                const profileIds = [];
                wishlistItems.each((idx, el) => {
                    profileIds.push($(el).attr('data-profileId'));
                });

                function updateState(profileItem) {
                    const selector = param.elToBeUpdated ? param.elToBeUpdated : param.wishlistItems;
                    const currentProfileItem = $(selector + '[data-profileId="' + profileItem.profileId + '"]');
                    const currentProfileItemState = profileItem.bookmarked ? WISHLISTED_CLASS : UNWISHLISTED_CLASS;

                    currentProfileItem.removeClass(WISHLISTED_CLASS).removeClass(UNWISHLISTED_CLASS);
                    currentProfileItem.addClass(currentProfileItemState);

                    if (param.contextualLabel) {
                        const label = profileItem.bookmarked ? param.labels.wishlisted : param.labels.unwishlisted;
                        currentProfileItem.find('.js-label').text(label);
                    }
                }

                Hop.wishlists.checkWishlistedItems(profileIds, updateState);
            }

            function updateWithoutConnectedAccount() {
                wishlistItems.addClass(UNWISHLISTED_CLASS);
            }

            ifConnected(updateWithConnectedAccount, updateWithoutConnectedAccount);
        },

        changeWishlistName: function (wishlistNewName) {
            function updateWishlistName(wishlistNewName) {
                $('.wishlistNameHeader').html(wishlistNewName);
            }

            Hop.wishlists.changeWishlistName({
                wishlistId: param.pageWishlistId,
                wishlistNewName: wishlistNewName,
                callback: function () {
                    updateWishlistName(wishlistNewName);
                    $('#wishlistEditNameModal').modal('hide');
                },
            });
        },

        scrollToClickedItem: function (clickedItem) {
            $('html,body').animate(
                {
                    scrollTop: clickedItem.offset().top - 80, // 80 is headerheight + little offset
                },
                600,
            );
        },

        getProfileItemsCount: function () {
            return $(param.profileItems + ':visible').length;
        },

        toggleEmptyProfilesSection: function (profileCount) {
            if (!profileCount || profileCount === 0) {
                $('#wishlistItemsEmpty').removeClass('hidden');
            } else {
                $('#wishlistItemsEmpty').addClass('hidden');
            }
        },

        modalCloseHandler: function () {
            if (param.redirectUrl) {
                window.location = param.redirectUrl;
            }
        },

        setHandlers: function () {
            const self = this;

            // update all wishlist items states (eg : on search page, wishlisted profile have a blue heart)
            $(window).on('load', () => {
                self.updateWishlistItemsState();
            });

            self.wishlistModal.modal.on('hide.bs.modal', () => {
                self.updateWishlistItemsState();
                if (!param.noScrollToItem) {
                    self.scrollToClickedItem(self.clickedItem);
                }
                self.toggleEmptyProfilesSection(self.getProfileItemsCount());
                self.modalCloseHandler();
            });

            // used only on wishlist detail page, remove directly a profile from a wishlist without displaying wishlist modal
            self.$root.on('click', '.wishlistRemoval', (e) => {
                const profileIdToRemove = $(e.target).closest('.wishlistRemoval').attr('data-profileId');
                Hop.wishlists.toggleProfile({
                    profileId: profileIdToRemove,
                    wishlistId: param.pageWishlistId,
                    source: param.source,
                    callback: function () {
                        $(e.target).closest(param.profileItems).remove();
                        self.toggleEmptyProfilesSection(self.getProfileItemsCount());
                        pushNotification(Hop.message('wishlist.profile.removal.success.message'));
                    },
                });
            });

            $('#wishlistChangeNameForm').on('submit', (e) => {
                e.preventDefault();
                self.changeWishlistName($(e.target).find('input').val());
            });

            $('#wishlistEditNameModal').on('hidden.bs.modal', () => {
                $('#wishlistChangeNameForm')[0].reset();
            });

            Hop.events.on(self.wishlistLoggedInEvent, (str) => {
                self.updateWishlistItemsState();
                self.clickedItem = $(param.wishlistItems + '[data-profileId="' + str + '"]');
                // tiny timeout is used to prevent conflict between signin/signup bootstrap modal and wishlist modal hide/show events
                setTimeout(() => {
                    self.wishlistModal.showWishlistModal(self.clickedItem);
                }, 10);
            });
            Hop.events.on('wishlist:updateItemStates', this.updateWishlistItemsState.bind(this));
        },

        clean: function () {
            this.wishlistModal.clean();
        },
    };

    const wishlistItemsContainer = new WishlistItemsContainer($root);

    return function destroy() {
        wishlistItemsContainer.clean();
    };
});
